<template>
  <header class="ecran-header">
    <div class="ecran-header__event">{{ nomEpreuve }}</div>
    <div class="ecran-header__separator">|</div>
    <div class="ecran-header__parcours">{{ titleResults }}</div>
    <div class="ecran-header__indicator" v-if="indicator">{{ indicator }}</div>
  </header>
</template>

<script>
export default {
  props: {
    nomEpreuve: {
      type: String,
      default: "",
    },
    titleResults: {
      type: String,
      default: "",
    },
    indicator: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.ecran-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  min-height: 48px;
  padding: 8px 16px;
  background-color: var(--darkblue);
  color: var(--lightgrey);
  font-size: 1.1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.ecran-header__event {
  font-weight: 700;
}

.ecran-header__separator {
  color: var(--orange);
  font-weight: 700;
}

.ecran-header__parcours {
  font-weight: 600;
  color: var(--orange);
}

.ecran-header__indicator {
  font-size: 0.85rem;
  opacity: 0.75;
  margin-left: auto;
}
</style>
